module.exports = __webpack_public_path__ + "static/media/points_reset.deaf223b.svg";